import { ResultsClient } from '../common/ResultsClient';

export class Dibels8ResultsClient extends ResultsClient {
    static BASE_URL = '/dibels8-api/results/v1/results';
}

export default Dibels8ResultsClient;
